<template>
  <span class="d-inline">
    <span>Next time</span>
    <v-select
      class="mx-2 mt-0 pt-0 d-inline-block height-20 width-90"
      required
      hide-details
      single-line
      append-icon=""
      text="text"
      value="value"
      height="14px"
      v-model="inboundOrOutbound"
      :items="inboundOrOutboundOptions"
    />
    <v-select
      class="mx-2 mt-0 pt-0 d-inline-block height-20 width-150"
      required
      hide-details
      single-line
      append-icon=""
      text="text"
      value="value"
      height="14px"
      v-model="setId"
      :items="setIdOptions"
    />
  </span>
</template>

<script>
import { toTitleCase } from "@/helpers/TextUtils";
import { parse } from "json5";

export default {
  name: "Journey",
  components: {},
  props: {
    value: {
      type: Object,
      required: true,
    },
    profileId: {
      required: true,
    },
  },
  data() {
    return {
      inboundOrOutbound: null,
      inboundOrOutboundOptions: [
        { text: "entering", value: "inbound" },
        { text: "exiting", value: "outbound" },
      ],
      setId: null,
      activeProfiles: this.$store.getters.nonDeletedOrExpiredProfiles,
    };
  },
  computed: {
    setIdOptions() {
      const poiDependencies = this.getPoiDependencies(this.profileId);
      return [{ text: "their Home", value: "home" }].concat(
        this.$store.getters.poiSets
          .filter((p) => poiDependencies.indexOf(p.name) !== -1)
          .map((p) => ({
            text: "a " + (p.display_name || toTitleCase(p.name)),
            value: p.name,
          }))
      );
    },
    action() {
      return {
        set_id: this.setId,
        direction: this.inboundOrOutbound,
      };
    },
  },
  methods: {
    getPoiDependencies(profileId) {
      const profile = this.activeProfiles.find((p) => p.id === profileId);
      if (!profile) return [];
      let ret = [];

      const profileDependencies =
        profile.annotations["sdk@profile_dependencies"];
      if (profileDependencies) {
        parse(profileDependencies).forEach((p) => {
          ret = ret.concat(this.getPoiDependencies(p));
        });
      }

      const profilePoiDependencies =
        profile.annotations["sdk@profile_poi_dependencies"];
      if (profilePoiDependencies) {
        ret = ret.concat(parse(profilePoiDependencies));
      }

      return ret;
    },
  },
  watch: {
    value: {
      handler (newVal) {
        this.setId = newVal.set_id ?? "home";
        this.inboundOrOutbound = newVal.direction ?? "inbound";
        this.$emit('input', this.action)
      },
      immediate: true
    },
    action(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>

<style scoped>
.input-field {
  height: 20px;
  display: inline-block;
}
</style>
